import React from 'react';
import { ToastContainer, toast } from 'react-toastify';
import { hashHistory } from 'react-router';
import { Helmet } from 'react-helmet';
import { connect } from 'react-redux';

import Content from '../components/Content';
import UiValidate from '../../../components/forms/validation/UiValidate';
import { setNewPassword } from '../../../store/auth/AuthActions';
import { domainName, hostTitle } from '../../../config/ui';



const validationOptions = {
  rules: {
    password: {
      required: true,
      minlength: 6,
      maxlength: 128,
      telemetryPassword: true,
    },
    passwordConfirm: {
      required: true,
      minlength: 6,
      maxlength: 128,
      telemetryPassword: true,
      equalTo: '#password',
    },
  },

  messages: {
    password: {
      required: 'Please enter your password',
    },
    passwordConfirm: {
      required: 'Please enter your password one more time',
      equalTo: 'Please enter the same password as above',
    },
  },
};
class Restore extends React.Component {
  constructor(props) {
    super(props);

    this.state = { token: null };
  }

  componentWillMount() {
    const { query } = this.props.location;
    if (query.token) {
      this.setState({ token: query.token });
    }
  }

  onSubmit(e) {
    e.preventDefault();

    const $form = $(this.refs.setPasswordForm);
    const $password = $(this.refs.password);

    if ($form.data('validator')) {
      if ($form.valid()) {
        this.props.setNewPassword({
          token: this.state.token,
          password: $password.val()
        }).then((response) => {
          if (response.error) {
            toast.error(`Something went wrong. ${this.props.auth.setPasswordError.message}`);
          } else {
            toast(
              'Your password has been changed, you may now login.',
              {
                onClose: () => hashHistory.push('/login'),
              },
            );
          }
        },
        () => toast.error('Something went wrong. Please try again later.'));
      }
    }
  }
  render() {
    const { isLoading } = this.props.auth;

    return (
      <div id="extr-page">
        <Helmet title={`Registration – ${hostTitle()}`} />
        <header id="header" className="animated fadeInDown">
          <div id="logo-group">
            <span id="logo">
              {' '}
              <img src={`assets/img/${domainName()}logo.png`} alt="SmartAdmin" />{' '}
            </span>
          </div>
          <span id="extr-page-header-space">
            <span className="hidden-mobile hiddex-xs">Already registered?</span>
            &nbsp;
            <a href="#login" className="btn btn-danger">
              Sign In
            </a>{' '}
          </span>
        </header>
        <div id="main" role="main" className="animated fadeInDown">
          {/* MAIN CONTENT */}
          <div id="content" className="container">
            <div className="row">
              <Content className="col-xs-12 col-sm-12 col-md-7 col-lg-8 hidden-xs hidden-sm" />
              <div className="col-xs-12 col-sm-12 col-md-5 col-lg-4">
                <div className="well no-padding">

                  <UiValidate options={validationOptions}>
                  <form
                    ref="setPasswordForm"
                    id="login-form"
                    className="smart-form client-form"
                    noValidate="novalidate"
                    onSubmit={this.onSubmit.bind(this)}
                  >
                    <header>Set New Password</header>

                    <fieldset>
                      <section>
                        <label className="input">
                          {' '}
                          <i className="icon-append fa fa-lock" />
                          <input
                            type="password"
                            name="password"
                            ref="password"
                            placeholder="New Password"
                            id="password"
                            autoComplete="new-password"
                          />
                        </label>
                      </section>

                      <section>
                        <label className="input">
                          {' '}
                          <i className="icon-append fa fa-lock" />
                          <input
                            type="password"
                            name="passwordConfirm"
                            placeholder="Confirm new password"
                            autoComplete="new-password"
                          />
                        </label>
                      </section>
                    </fieldset>
                    <footer>
                      <button type="submit" className="btn btn-primary">
                        Submit
                      </button>
                      </footer>
                      {isLoading &&
                        <div className="cover">
                          <div className="spinner inline"></div>
                        </div>
                      }
                  </form>
                  </UiValidate>
                </div>
              </div>
            </div>
          </div>
        </div>
        <ToastContainer />
      </div>
    );
  }
}

export default connect(
  state => ({ auth: state.auth }),
  dispatch => ({
    setNewPassword: data => dispatch(setNewPassword(data)),
  }),
)(Restore);



// WEBPACK FOOTER //
// ./src/routes/auth/containers/Restore.js